import {
  DraftMessage,
  DraftMessagesCache,
} from '@web/conversations/DraftMessagesProvider/draftMessages.types';

export const DRAFT_MESSAGES_CACHE_KEY = 'sling/draftMessages';

const getData = (): Record<number, DraftMessage> => {
  const rawData = sessionStorage.getItem(DRAFT_MESSAGES_CACHE_KEY);
  if (rawData) {
    try {
      return JSON.parse(rawData);
    } catch (e) {
      return {};
    }
  }

  return {};
};

const setData = (data: Record<number, DraftMessage>) => {
  try {
    sessionStorage.setItem(DRAFT_MESSAGES_CACHE_KEY, JSON.stringify(data));
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

const clearData = () => sessionStorage.setItem(DRAFT_MESSAGES_CACHE_KEY, null);

export const DraftMessageSessionStoreCache: DraftMessagesCache = {
  getData,
  setData,
  clearData,
};
